/**
 * INV.1 — gate admin 3PL routes. When inventory.3pl is off, surface is absent
 * (redirect home), not disabled.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useFeatureFlag } from "./featureFlags";

export function Require3pl({ children }) {
  const enabled = useFeatureFlag("inventory.3pl");
  if (!enabled) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

/** Route component wrapper for the lazy route table. */
export function with3plGate(Component) {
  const Gated = (props) => (
    <Require3pl>
      <Component {...props} />
    </Require3pl>
  );
  Gated.displayName = `With3pl(${Component.displayName || Component.name || "Component"})`;
  return Gated;
}

export default Require3pl;
